import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";
import rehypeRaw from "rehype-raw";
import styles from "./MarkdownRenderer.module.css";
import { getMarkdownComponents, sanitizeOptions } from "./MarkdownRendererComponents";
interface IMarkdownRendererProps {
  content: string;
  className?: string;
}

export const MarkdownRenderer: React.FC<IMarkdownRendererProps> = ({ content, className }) => {
  const nonEnglishRegex = /[א-ת]+/;
  const directionClassName = content.length > 0 && !nonEnglishRegex.test(content) ? "ltr" : "rtl";
  return (
    <div
      className={`${styles["markdown-container"]} ${className || ""}`}
      style={{
        direction: directionClassName,
        textAlign: directionClassName === "ltr" ? "left" : "right",
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, [rehypeSanitize, sanitizeOptions]]}
        components={getMarkdownComponents(directionClassName)}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};
